"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalArrayQueryType = exports.emptyResponse = exports.EmptyResponseSchema = exports.replyWithCount = exports.CountResponseSchema = exports.replyWithDeleted = exports.DeleteResponseSchema = exports.PaginationResponseSchema = exports.PaginationResponseFields = exports.SortOrderSchema = exports.SortOrder = exports.PaginationQuerySchema = exports.PaginationQueryFields = exports.TotalSchema = exports.SkipSchema = exports.TakeSchema = exports.SearchStringSchema = exports.TeamApiKeyIdParamsSchema = exports.TeamUserIdParamsSchema = exports.TeamCampaignKeywordIdParamsSchema = exports.TeamCampaignRegionIdParamsSchema = exports.TeamCampaignIdParamsSchema = exports.TeamIdParamsSchema = exports.IdsResponseSchema = exports.IdResponseSchema = exports.IdParamsSchema = exports.MAX_TAKE = exports.DEFAULT_TAKE = exports.DEFAULT_SKIP = void 0;
const typebox_1 = require("@sinclair/typebox");
const db_1 = require("./db");
const primitives_1 = require("./primitives");
exports.DEFAULT_SKIP = 0;
exports.DEFAULT_TAKE = 50;
exports.MAX_TAKE = 1000;
exports.IdParamsSchema = (0, primitives_1.StrictObject)({
    id: db_1.IdSchema,
}, { title: "Id", description: "Id in a query parameter" });
exports.IdResponseSchema = (0, primitives_1.StrictObject)({
    id: db_1.IdSchema,
});
exports.IdsResponseSchema = (0, primitives_1.StrictObject)({
    ids: typebox_1.Type.Array(db_1.IdSchema),
});
exports.TeamIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
}, {
    title: "Team",
    description: "Team to use",
});
exports.TeamCampaignIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
    campaignId: db_1.IdSchema,
}, {
    title: "Team and Campaign",
    description: "Combined Team and Campaign Id in a query parameter",
});
exports.TeamCampaignRegionIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
    campaignId: db_1.IdSchema,
    regionId: db_1.IdSchema,
}, {
    title: "Team, Campaign, and Region",
    description: "Combined Team, Campaign, and Country Id in a query parameter",
});
exports.TeamCampaignKeywordIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
    campaignId: db_1.IdSchema,
    keywordId: db_1.IdSchema,
}, {
    title: "Team, Campaign and Keyword",
    description: "Combined Team, Campaign and Country Id in a query parameter",
});
exports.TeamUserIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
    userId: db_1.IdSchema,
}, {
    title: "Team and User",
    description: "Combined Team and User Id in a query parameter",
});
exports.TeamApiKeyIdParamsSchema = (0, primitives_1.StrictObject)({
    teamId: db_1.IdSchema,
    apiKeyId: db_1.IdSchema,
}, {
    title: "Team and User",
    description: "Combined Team and Team Api Key Id in a query parameter",
});
exports.SearchStringSchema = typebox_1.Type.String({
    title: "Search",
    description: "Matches by strings starting with this value",
    minLength: 1,
    maxLength: 100,
    examples: ["ex"],
});
exports.TakeSchema = typebox_1.Type.Integer({
    default: exports.DEFAULT_TAKE,
    minimum: 0,
    maximum: exports.MAX_TAKE,
    title: "Maximum number of results to return",
    description: "Use take=0 to return only the count",
    examples: [exports.DEFAULT_TAKE],
});
exports.SkipSchema = typebox_1.Type.Integer({
    default: exports.DEFAULT_SKIP,
    minimum: 0,
    title: "Offset in the results to jump to",
    examples: [0],
});
exports.TotalSchema = typebox_1.Type.Integer({
    minimum: 0,
    title: "Total matching results",
    description: "Total number of results which match the query (but not limited by pagination)",
    examples: [14],
});
exports.PaginationQueryFields = {
    take: exports.TakeSchema,
    skip: exports.SkipSchema,
};
exports.PaginationQuerySchema = typebox_1.Type.Object(exports.PaginationQueryFields, {
    title: "Pagination",
    description: "Defines the page of results to return using number of items to skip (page*PAGE_SIZE) and the number to take (PAGE_SIZE)",
});
var SortOrder;
(function (SortOrder) {
    SortOrder["ASCENDING"] = "ASC";
    SortOrder["DESCENDING"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
exports.SortOrderSchema = (0, primitives_1.StringUnion)([SortOrder.ASCENDING, SortOrder.DESCENDING], {
    title: "Sort Order",
    description: "Sort by ascending or descending values",
});
exports.PaginationResponseFields = {
    take: exports.TakeSchema,
    skip: exports.SkipSchema,
};
exports.PaginationResponseSchema = (0, primitives_1.StrictObject)(exports.PaginationResponseFields, {
    title: "Pagination",
    description: "Describes the pagination used when generating the results",
});
exports.DeleteResponseSchema = (0, primitives_1.StrictObject)({
    deleted: typebox_1.Type.Integer({
        title: "Number of deleted",
        description: "One or more if the item are actually deleted, 0 if nothing was deleted (not found or for another reason)",
        minimum: 0,
        examples: [0],
    }),
});
/**
 * Helper function to construct a deleted response
 *
 * @param count
 * @returns
 */
function replyWithDeleted(count) {
    return {
        deleted: count,
    };
}
exports.replyWithDeleted = replyWithDeleted;
exports.CountResponseSchema = (0, primitives_1.StrictObject)({
    count: typebox_1.Type.Integer({
        title: "Number of items",
        description: "Number of items",
        minimum: 0,
        examples: [0],
    }),
});
/**
 * Helper function to construct a count response
 *
 * @param count
 * @returns
 */
function replyWithCount(count) {
    return {
        count,
    };
}
exports.replyWithCount = replyWithCount;
/**
 * An empty response from the API
 *
 * This is not generally to be used other than a placeholder, but could have us in special cases
 */
exports.EmptyResponseSchema = (0, primitives_1.StrictObject)({}, { title: "Empty" });
function emptyResponse() {
    return {};
}
exports.emptyResponse = emptyResponse;
// Optional or array for querystring
// Allows you to use ?type=value1&type=value2
function OptionalArrayQueryType(schema) {
    return typebox_1.Type.Optional(typebox_1.Type.Array(schema, {
        default: [],
    }));
}
exports.OptionalArrayQueryType = OptionalArrayQueryType;
